export default __webpack_public_path__ + "UI/assets/media/bg-pricing-card-title-92ef2d0f.svg";